<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        class="fill-current"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.4144 18.123L16.7073 11.4159C16.5197 11.2284 16.2654 11.123 16.0002 11.123C15.7349 11.123 15.4806 11.2284 15.293 11.4159L8.58594 18.123L10.0002 19.5373L16.0002 13.5373L22.0001 19.5373L23.4144 18.123Z"
        />
    </svg>
</template>
